module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "foot-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.onJump('/privacy-policy')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ic-policy.png")
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onJump('terms-of-use')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ic-terms.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "qr-area"
  }, [_c('i', {
    class: {
      'hv-wechat': _vm.isClick
    },
    on: {
      "click": function($event) {
        _vm.isClick = !_vm.isClick;
      }
    }
  }), _vm._v(" "), (_vm.isClick) ? _c('img', {
    staticClass: "qr",
    attrs: {
      "src": require("../assets/images/ic-qrcode.png")
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.facebook.com/indracoreCRM/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ic-fb.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://twitter.com/IndraCoreGlobal/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ic-twitter.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/indracoreglobal/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ic-ins.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-area"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("INDRACORE Inc. © 2017-2025")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f15d999"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/foot.vue
// module id = 695
// module chunks = 17